import { CoreButton } from '@components'
import AddExpenseIcon from '@images/expenses/add-expense.svg?react'
import AddExpenseModal from '@views/expenseManagement/AddExpenseModal/AddExpenseModal'
import { useGetReportQuery, useMerchantQry } from 'mmfintech-backend-api'
import type { ReportState } from 'mmfintech-backend-api/types'
import { GlobalContext, tr } from 'mmfintech-commons'
import { useContext } from 'react'
import { useLocation } from 'react-router-dom'

const actionStatuses: ReportState[] = ['NEW', 'EDIT']

interface AddEditExpenseButtonProps {
  reportId?: number
  reload?: () => void
}

const AddExpenseButton = ({ reportId, reload }: AddEditExpenseButtonProps) => {
  const { modalHide, modalShow } = useContext(GlobalContext)

  const { pathname } = useLocation()
  const { merchant } = useMerchantQry()

  const { data: report } = useGetReportQuery({ reportId }, { skip: !reportId })

  const handleCreateExpenseModalOpen = () => {
    modalShow({
      header: tr('FRONTEND.EXPENSES.EXPENSE_MODAL.CREATE_NEW_EXPENSE', 'Create New Expense'),
      content: <AddExpenseModal onClose={modalHide} reportId={reportId} reload={reload} />,
      options: {
        size: 'large',
        closeOnEscape: false,
        closeOnClickOutside: false
      }
    })
  }

  if (reportId && merchant?.merchantId !== report?.merchantId) {
    return null
  }

  if (!(pathname === '/expense-management/reports') && !actionStatuses.includes(report?.state)) {
    return null
  }

  return (
    <CoreButton
      text={tr('FRONTEND.EXPENSE_MANAGEMENT.ADD_EXPENSE', 'Add Expense')}
      LeftIcon={<AddExpenseIcon />}
      data-test='button-add-expense-modal'
      onClick={handleCreateExpenseModalOpen}
      size='large'
    />
  )
}

export default AddExpenseButton
